import React, {createContext, useState} from "react";
import PropTypes from "prop-types";

export const Context = createContext({});

export const Provider = props => {

    //intitial values can be obtained/set from the props
    const {children} = props;

    const [faqBody, setFaqBody] = useState(null);
    const [faqList, setFaqList] = useState(null);
    //const [faqSlugList, setFaqSlugList] = useState([]);
    const [renderFaqComponent, setRenderFaqComponent] = useState(false);
    const [renderHelpComponent, setRenderHelpComponent] = useState('');

    const addSelectedFaq = faq => {
        setFaqBody(faq);
    };

    const addFaqList = faqList => {
        setFaqList(faqList)
    };

    const changeFaqRenderState = renderState => {
        setRenderFaqComponent(renderState);
    }
    const changeHelpRenderState = renderState => {
        setRenderHelpComponent(renderState);
    }

//context object
    const faqContext = {
        faqBody, setFaqBody, addSelectedFaq,
        faqList, setFaqList, addFaqList,
        renderFaqComponent, setRenderFaqComponent,
        changeFaqRenderState,
        renderHelpComponent, setRenderHelpComponent,
        changeHelpRenderState
    };

    return <Context.Provider value={faqContext}>
        {children}
    </Context.Provider>

};

export const {FaqConsumer} = Context;

Provider.propTypes = {
    faqBody: PropTypes.object,
    renderFaqComponent: PropTypes.bool
};

Provider.defaultProps = {
    faqBody: {},
    renderFaqComponent: false
};